import { initializeApp } from "firebase/app";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDIypdtoJzziPHWgjFKWHaogSVNQCVNoss",
    authDomain: "gynoledger.firebaseapp.com",
    projectId: "gynoledger",
    storageBucket: "gynoledger.appspot.com",
    messagingSenderId: "1011027334245",
    appId: "1:1011027334245:web:9ef88e88dd51d415f7a28c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const provider = new GoogleAuthProvider();
export const firestore = getFirestore(app);
